module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enableFeedback) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.categories.length) ? _c('div', {
    attrs: {
      "id": "feedback-category"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategory),
      expression: "selectedCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("feedback.selectCategory")))]), _vm._v(" "), _vm._l((_vm.categories), function(cat) {
    return _c('option', {
      key: cat.id
    }, [_vm._v(_vm._s(cat))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tools"
    }
  }, [_vm._v("\n    Draw:\n    "), (_vm.drawOptions.includes('Point')) ? _c('button', {
    staticClass: "small",
    class: {
      active: _vm.draw === 'Point'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDrawTool('Point')
      }
    }
  }, [_vm._v("Points")]) : _vm._e(), _vm._v(" "), (_vm.drawOptions.includes('Polygon')) ? _c('button', {
    staticClass: "small",
    class: {
      active: _vm.draw === 'Polygon'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDrawTool('Polygon')
      }
    }
  }, [_vm._v("Polygons")]) : _vm._e()]), _vm._v(" "), (_vm.senderEmailIsRequired) ? _c('div', {
    attrs: {
      "id": "sender"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senderEmail),
      expression: "senderEmail"
    }],
    attrs: {
      "id": "message-sender",
      "type": "email",
      "name": "email",
      "placeholder": "Write your email"
    },
    domProps: {
      "value": (_vm.senderEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.senderEmail = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "message"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "id": "message-text",
      "rows": "6",
      "placeholder": "Write your message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "buttons"
    }
  }, [_c('button', {
    staticClass: "small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.disableFeedback
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    attrs: {
      "type": "button",
      "disabled": _vm.drew === false
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('button', {
    staticClass: "small danger",
    attrs: {
      "type": "button",
      "disabled": _vm.disableSend
    },
    on: {
      "click": _vm.sendFeedback
    }
  }, [_vm._v("Send")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74728dc0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feedback.vue
// module id = 637
// module chunks = 2